var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 117,
    viewBox: "0 0 231 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.493 112.226L230.001 108.024V72.4629L226.493 79.8917V112.226Z",
    fill: "#D0D1D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0103 72.4629L2.64648 85.433L226.492 79.8917L230 72.4629H28.0103Z",
    fill: "#6B6094"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64648 85.4334V116.001H226.492V112.226V79.8921L2.64648 85.4334Z",
    fill: "#766AA3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.28 70.7572L216.887 70.5137V70.879L201.991 78.3078V81.7178H201.703L201.991 81.9614L220.28 70.7572Z",
    fill: "#766AA3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.991 78.308L216.888 70.8792V70.5139V49.3232L195.032 52.1243H201.991V78.308Z",
    fill: "#D0D1D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.644 52.124H24.502V81.7786H183.644V52.124Z",
    fill: "#F38498"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5011 52.124H0V81.7786H24.5011V52.124Z",
    fill: "#D94760"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.99 78.3077V52.124H195.03H183.643V81.7177H201.702H201.99V78.3077Z",
    fill: "#D94760"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.17 6.39306V48.7133L225.63 43.2939V3.89648L194.17 6.39306Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M225.63 3.89712L228.218 3.65354V0L194.17 2.13123V6.39369L225.63 3.89712Z",
    fill: "#424152"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M194.17 53.9496L228.218 46.5816V42.8672L225.63 43.2934L194.17 48.7128V53.9496Z",
    fill: "#424152"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M194.17 48.7135V6.39332V2.13086H7.88086V53.9502H194.17V48.7135Z",
    fill: "#555369"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0747 2.13086H26.2266V53.9502H69.0747V2.13086Z",
    fill: "#96999F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGot);
export default __webpack_public_path__ + "static/media/got.eb9ff0d6.svg";
export { ForwardRef as ReactComponent };